import { useChargers } from './queries/chargerQueries';
import { useStationsBatch } from './queries/stationQueries';
import { useDRResourcesBatch } from './queries/drResourceQueries';
/**
 * 충전기 데이터를 간결하게 사용하는 헬퍼 훅
 * @param {Object} params - 쿼리 파라미터
 * @returns {Object} 충전기 데이터와 관련 정보
 */
export const useChargersSimple = (params = {}) => {
  const { data: chargersData, isLoading: chargersLoading, error } = useChargers(params);
  
  const chargers = chargersData?.Items || [];
  const stationIds = chargers.map(charger => charger.StationSysId).filter(Boolean);
  const drResourceIds = chargers.map(charger => charger.DrResourceSysId).filter(Boolean);
  
  const { data: stations = [], isLoading: stationsLoading } = useStationsBatch(stationIds);
  const { data: drResources = [], isLoading: drResourcesLoading } = useDRResourcesBatch(drResourceIds);
  // Station 정보를 쉽게 찾을 수 있는 헬퍼 함수
  const getStation = (stationId) => {
    return stations.find(station => station?.StationSysId === stationId);
  };
  const getDrResource = (drResourceId) => {
    return drResources.find(drResource => drResource?.DrResourceSysId === drResourceId);
  };
  return {
    chargers,
    stations,
    drResources,
    getStation,
    getDrResource,
    getDrResourceById: (drResourceId) => drResources.find(drResource => drResource?.DrResourceSysId === drResourceId),
    isLoading: chargersLoading || stationsLoading || drResourcesLoading,
    error,
    // 추가 헬퍼 메서드들
    getChargerById: (chargerId) => chargers.find(c => c.ChargerSysId === chargerId),
    getChargersByStation: (stationId) => chargers.filter(c => c.StationSysId === stationId),
    totalCount: chargersData?.Total || chargers.length, // API 응답의 Total 필드 사용
  };
};

export default useChargersSimple;
